import React from "react"

import { images } from "../../config/image-definitions"
const { refreshIcon } = images

const RefreshButton = ({ onClick }) => (
    <img
        src={refreshIcon}
        className="btn-refresh"
        alt="Refresh"
        onClick={onClick}
    />
)

export default RefreshButton
